import { h } from 'preact';
import { WishlistProductCard } from './WishlistProductCard';
import { t } from '../../theme/locales';
export const ShowWishlist = ({ wishlist , handleRemoveFromWishlist , removing , showHeartIcon =true  })=>{
    return h('div', {
        className: 'wishlist-page__grid',
        role: 'list'
    }, [
        removing && h('div', {
            className: 'wishlist-page__removing-overlay',
            role: 'status',
            'aria-live': 'polite'
        }, t('wishlist.removing')),
        wishlist.listcontents.length > 0 ? wishlist.listcontents.map((item)=>{
            return h(WishlistProductCard, {
                key: `${wishlist.lid}-${item.epi}-${item.empi || ''}-${item.du || ''}`,
                item,
                list: wishlist,
                handleRemoveFromWishlist,
                showHeartIcon
            });
        }) : h('div', {
            className: 'wishlist-page__empty'
        }, t('wishlist.no_items'))
    ]);
};
